"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0.3 0 15 15';

var Person = function Person() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M7.41695,4.1877 C6.52295,4.1877 5.79545,4.9147 5.79545,5.8087 C5.79545,6.7027 6.52295,7.4297 7.41695,7.4297 C8.31045,7.4297 9.03795,6.7027 9.03795,5.8087 C9.03795,4.9147 8.31045,4.1877 7.41695,4.1877 M7.41695,8.5452 C5.90745,8.5452 4.67995,7.3177 4.67995,5.8087 C4.67995,4.3002 5.90745,3.0727 7.41695,3.0727 C8.92595,3.0727 10.15345,4.3002 10.15345,5.8087 C10.15345,7.3177 8.92595,8.5452 7.41695,8.5452"
  }), _react["default"].createElement("path", {
    d: "M12.0654,11.3059 C10.8484,10.0369 9.2299,9.3174 7.5409,9.3174 C5.8129,9.3174 4.1654,10.0664 2.9409,11.3864 C2.0114,10.3264 1.4459,8.9394 1.4459,7.4214 C1.4459,4.1009 4.1474,1.3994 7.4684,1.3994 C10.7889,1.3994 13.4909,4.1009 13.4909,7.4214 C13.4909,8.9009 12.9534,10.2564 12.0654,11.3059 M3.7494,12.1534 C4.7644,11.0559 6.1224,10.4329 7.5409,10.4329 C8.9279,10.4329 10.2629,11.0319 11.2704,12.0879 C10.2329,12.9349 8.9094,13.4439 7.4684,13.4439 C6.0654,13.4439 4.7744,12.9609 3.7494,12.1534 M7.4684,0.2839 C3.5264,0.2839 0.3304,3.4799 0.3304,7.4214 C0.3304,11.3639 3.5264,14.5594 7.4684,14.5594 C11.4099,14.5594 14.6059,11.3639 14.6059,7.4214 C14.6059,3.4799 11.4099,0.2839 7.4684,0.2839"
  }));
};

var _default = (0, _createSvgIcon["default"])(Person, {
  viewBox: viewBox
});

exports["default"] = _default;